import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as intlTelInput from 'intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { UtilityBasicInfo } from 'src/app/models/utility.model';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  @ViewChild('telInput') telInput: any;
  @Input() phoneNumber = '';
  @Input() cssClass = 'form-control';
  @Output() phoneNumberChange = new EventEmitter<string>();
  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('openRegisterSuccessModal') openRegisterSuccessModal: ElementRef;
  @ViewChild('openOtpModal') openOtpModal: ElementRef;
  @ViewChild('closeOtpModal') closeOtpModal: ElementRef;
  @ViewChildren('otpInput0, otpInput1, otpInput2, otpInput3') otpInputs: any;

  iti: any;
  isInvalid = false;
  selectedCountryCode: any;
  constructor(
    private accountService: AccountKycService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService
  ) {}
  strongPassword = false;
  accountNumber: string | null;
  extractedAccountNumber: string | null;
  email: string;
  showPw: boolean = false;
  pass: string = '';
  validAccNo = false;
  invalidAccNo = false;
  customerId?: number | null;
  customerName: string = '';
  typeOfCustomer?: number;
  utility: UtilityBasicInfo;

  // OTP verification
  otpDigits: string[] = ['', '', '', ''];
  otpError: string = '';
  otpExpired: boolean = false;
  otpLoading: boolean = false;
  maskedEmail: string = '';
  registeredEmail: string = '';
  registeredAccountNumber: string | null = null;
  resendCooldown: number = 0;
  private resendInterval: any;

  ngOnInit() : void {
    var utilityRoute = this.route.snapshot.paramMap.get('utility') || '';

    if (utilityRoute) {
      this.tryGetUtilityByName(utilityRoute.replace(new RegExp("-", "g"), " "));
    } else this.router.navigate(['']);
  }
  ngAfterViewInit() {
  }
  ngOnChanges(changes: SimpleChanges) {}
  ngOnDestroy() {
    if(this.iti) {
      this.iti.destroy();
    }
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
    }
  }

  onFocus = () => {
    if (this.phoneNumber == undefined || this.phoneNumber == '') {
      var getCode = this.iti.getSelectedCountryData().dialCode;
      this.phoneNumber = '+' + getCode;
    }
  };

  onBlur = () => {
    this.isInvalid = false;
    if (this.phoneNumber != undefined && this.phoneNumber.trim()) {
      if (this.iti.isValidNumber()) {
        this.isInvalid = false;
      } else {
        this.isInvalid = true;
      }
    }
  };

  onPasswordStrengthChanged(event: boolean) {
    this.strongPassword = event;
  }
  onInputKeyPress = (event: KeyboardEvent) => {
    const allowedChars = /[0-9\+\-\ ]/;
    const allowedCtrlChars = /[axcv]/; // Allows copy-pasting
    const allowedOtherKeys = [
      'ArrowLeft',
      'ArrowUp',
      'ArrowRight',
      'ArrowDown',
      'Home',
      'End',
      'Insert',
      'Delete',
      'Backspace',
    ];

    if (
      !allowedChars.test(event.key) &&
      !(event.ctrlKey && allowedCtrlChars.test(event.key)) &&
      !allowedOtherKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  };

  formatIntlTelInput() {
    if (typeof intlTelInputUtils !== 'undefined') {
      // utils are lazy loaded, so must check
      var currentText = this.iti.getNumber(intlTelInputUtils.numberFormat.E164);
      if (typeof currentText === 'string') {
        // sometimes the currentText is an object :)
        this.iti.setNumber(currentText); // will autoformat because of formatOnDisplay=true
      }
    }
  }

  register() {
    if(this.typeOfCustomer == 2) {
      if (!this.extractedAccountNumber) {
        this.toastr.warning(
          'Please enter a valid Account number / Meter number.'
        );
        return;
      }
    }
    if(!this.email) {
      this.toastr.warning('Email is mandatory!');
      return;
    }
    else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   
      if (!emailRegex.test(this.email)) {
        this.toastr.warning("Invalid Email format.");
        return;
      }
    }
    if (this.pass?.length < 8) {
      this.toastr.warning('Password must be at least 8 characters');
      return;
    }
    if (this.pass?.search(/[a-z]/i) < 0) {
      this.toastr.warning('Password must contain at least one letter.');
      return;
    }
    if (this.pass?.search(/[0-9]/) < 0) {
      this.toastr.warning('Password must contain at least one digit.');
      return;
    }
    if (this.pass?.search(/[$&+,:;=?@#|'<>.^*()%!-]/) < 0) {
      this.toastr.warning(
        "Password must contain at least one special character ($&+,:;=?@#|'<>.^*()%!-)."
      );
      return;
    }
    if(this.email) {
      let userId = this.email.split('@')[0];
      if (this.pass.toLowerCase().includes(userId.toLowerCase())) {
        this.toastr.warning('Your password must not contain your email.');
        return;
      }
    }
    
    if (!this.iti.isValidNumber()) {
      this.toastr.warning('Please enter a valid phone number.');
      return;
    }
    const data = this.iti.getSelectedCountryData();

    var obj = {
      accountNumber: this.extractedAccountNumber,
      password: this.pass,
      email: this.email,
      utility: this.utility.id, 
      phoneNumber: this.phoneNumber,
      dialCode: data.dialCode,
      customerId: this.customerId,
      cookieConsentGiven: this.parseConsent()
    };
    this.accountService.register(obj).subscribe({
      next: (response) => {
        const responseData = response.body;

        const isPending = responseData?.status === 600 || responseData?.status === 'Pending';
        const isOk = responseData?.status === 200 || responseData?.status === 'OK';

        if ((isOk || isPending) && responseData?.data != undefined) {
          this.registeredEmail = this.email;
          this.registeredAccountNumber = this.extractedAccountNumber;
          this.maskedEmail = this.maskEmail(this.email);
          this.otpDigits = ['', '', '', ''];
          this.otpError = '';
          this.otpExpired = false;
          this.openOtpModal?.nativeElement?.click();
          this.startResendCooldown();

          if (!isPending) {
            this.accountNumber = null;
            this.extractedAccountNumber = null;
            this.phoneNumber = '';
            this.customerName = '';
            this.pass = '';
          }
          this.email = '';
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  checkAccountOrMeterNumber() {
    var obj = {
      utilityId: this.utility.id,
      searchValue: this.accountNumber,
    };
    if (this.accountNumber == '' || this.accountNumber == null) {
      this.validAccNo = false;
      this.invalidAccNo = false;
      this.accountNumber = null;
      this.customerId = null;
      this.extractedAccountNumber = null;
      return;
    }
    this.accountService.checkAccountOrMeterNumber(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (
          (responseData?.status === 200 || responseData?.status === 'OK') &&
          responseData?.data != undefined
        ) {
          this.validAccNo = true;
          this.invalidAccNo = false;
          this.customerId = responseData.data.id;
          this.extractedAccountNumber = responseData.data.accountNumber ?? null;
          this.customerName = responseData.data.tenantName;
        } else {
          this.invalidAccNo = true;
          this.validAccNo = false;
          this.customerId = null;
          this.extractedAccountNumber = null;
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  showPassword() {
    this.showPw = !this.showPw;
  }

  setCategory(typeOfCustomer: number) {
    this.typeOfCustomer = typeOfCustomer;
    setTimeout(() => {
      this.iti = intlTelInput(this.telInput.nativeElement, {
        utilsScript:
          'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
        // initialCountry: 'gh',
        initialCountry: "auto",
        nationalMode: true,
        separateDialCode: true,
        autoPlaceholder: 'off',
        geoIpLookup: callback => {
          fetch("https://ipapi.co/json")
            .then(res => res.json())
            .then(data => callback(data.country_code))
            .catch(() => callback("us"));
        },
      });
      this.selectedCountryCode = this.iti.getSelectedCountryData().dialCode;
    }, 0);

  }

  onOtpDigitInput(event: any, index: number) {
    const value = event.target.value;
    if (value && !/^\d$/.test(value)) {
      this.otpDigits[index] = '';
      return;
    }
    this.otpError = '';
    if (value && index < 3) {
      const inputs = this.otpInputs.toArray();
      inputs[index + 1].nativeElement.focus();
    }
  }

  onOtpKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      const inputs = this.otpInputs.toArray();
      inputs[index - 1].nativeElement.focus();
    }
  }

  onOtpPaste(event: ClipboardEvent) {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text') || '';
    const digits = paste.replace(/\D/g, '').substring(0, 4);
    for (let i = 0; i < 4; i++) {
      this.otpDigits[i] = digits[i] || '';
    }
    if (digits.length > 0) {
      const inputs = this.otpInputs.toArray();
      const focusIndex = Math.min(digits.length, 3);
      inputs[focusIndex].nativeElement.focus();
    }
    this.otpError = '';
  }

  verifyOtp() {
    const otpCode = this.otpDigits.join('');
    if (otpCode.length !== 4) {
      this.otpError = 'You have entered a wrong code. Please check the code and try again';
      return;
    }
    this.otpLoading = true;
    this.otpError = '';
    this.otpExpired = false;
    var obj = {
      email: this.registeredEmail,
      otpCode: otpCode,
      utilityId: this.utility.id,
      accountNumber: this.registeredAccountNumber
    };
    this.accountService.verifyOtp(obj).subscribe({
      next: (response) => {
        this.otpLoading = false;
        const responseData = response.body;
        if (
          (responseData?.status === 200 || responseData?.status === 'OK') &&
          responseData?.data != undefined
        ) {
          this.closeOtpModal?.nativeElement?.click();
          setTimeout(() => {
            this.openRegisterSuccessModal?.nativeElement?.click();
          }, 300);
        } else {
          const msg = responseData?.message || 'Verification failed.';
          this.otpError = msg;
          this.otpExpired = msg.toLowerCase().includes('expired');
        }
      },
      error: (_) => {
        this.otpLoading = false;
        this.otpError = 'An error occurred. Please try again.';
      },
    });
  }

  resendOtp() {
    if (this.resendCooldown > 0 && !this.otpExpired) return;
    var obj = {
      email: this.registeredEmail,
      utilityId: this.utility.id,
      accountNumber: this.registeredAccountNumber
    };
    this.accountService.resendOtp(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (
          (responseData?.status === 200 || responseData?.status === 'OK') &&
          responseData?.data != undefined
        ) {
          this.otpError = '';
          this.otpExpired = false;
          this.otpDigits = ['', '', '', ''];
          this.startResendCooldown();
          this.toastr.success('A new verification code has been sent.');
        } else {
          this.otpError = responseData?.message || 'Failed to resend code.';
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while resending code.');
      },
    });
  }

  startResendCooldown() {
    this.resendCooldown = 60;
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
    }
    this.resendInterval = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) {
        clearInterval(this.resendInterval);
      }
    }, 1000);
  }

  maskEmail(email: string): string {
    if (!email) return '';
    const [local, domain] = email.split('@');
    if (local.length <= 2) {
      return local[0] + '***@' + domain;
    }
    return local[0] + '***' + local[local.length - 1] + '@' + domain;
  }

  closeSuccessfullRegistrationModal() {
    this.closeModal?.nativeElement?.click();
  }
  
  proceedToLogin() {
    this.closeSuccessfullRegistrationModal();
    this.router.navigate(['/new-connection/' + this.utility.name + '/login']);
  }

  tryGetUtilityByName(name: string) {
    this.utilityService.getByName(name).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK' && responseData.data) {
          this.utility = responseData.data;
          this.fetchKycConfiguration();
        } else {
          this.router.navigate(['']);
        }
      },
      error: (_) => {
        this.router.navigate(['']);
      },
    });
  }

  fetchKycConfiguration() {
    this.utilityService.getKycConfiguration(this.utility.id).subscribe({
      next: (response) => {
        const data = response.body?.data;
        if (data) {
          if (data.utilityLogo) {
            localStorage.setItem('kycUtilityLogo', data.utilityLogo);
          }
          if (data.utilityName) {
            localStorage.setItem('kycUtilityName', data.utilityName);
          }
        }
      }
    });
  }

  parseConsent(){
  let consent = localStorage.getItem('cookieConsent');
  return consent ? consent == 'accepted' : false;
}
}
